import { createAction } from "redux-actions";

import * as types from "./types";

export const receiveDocumentTemplates = createAction(
  types.RECEIVE_DOCUMENT_TEMPLATES,
  ({ documents }) => ({ documents })
);
